/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import { ResponderPesquisaPage } from '../pages/responder-pesquisa/ResponderPesquisaPage'
import { ConfirmarClienteConsultoria } from '../pages/confirmar-cliente-consultoria/ConfirmarClienteConsultoria'
import { ConfirmarFinalizarClienteConsultoria } from '../pages/confirmar-cliente-consultoria/ConfirmarFinalizarClienteConsultoria'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {auth} = useAuth()

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='/responder-pesquisa/*' element={<ResponderPesquisaPage />} />
          <Route path='/confirmar-cliente-consultoria-descricao/*' element={<ConfirmarClienteConsultoria />} />
          <Route path='/confirmar-finalizar-cliente-consultoria-descricao/*' element={<ConfirmarFinalizarClienteConsultoria />} />
          {auth ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/inicio' />} />
            </>
          ) : (
            <>
              <Route path='/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
